import { Box, Switch, useColorMode } from "@chakra-ui/react";
import { CiLight } from "react-icons/ci";
import { MdDarkMode } from "react-icons/md";

export function ColorModeButton() {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Box position="relative">
      <Switch
        size="md"
        onChange={toggleColorMode}
        isChecked={colorMode === "dark"}
        position="relative"
        cursor="pointer"
        flexShrink={0}
        mx={{ md: 1 }}
        rounded="base"
        borderWidth="base"
        bg={colorMode === "dark" ? "#2c3b45" : "transparent"}
        sx={{ ".chakra-switch__track": { bg: "transparent" } }}
      />

      {colorMode === "dark" && (
        <Box
          pointerEvents="none"
          position="absolute"
          top="1/2"
          left={2}
          transform="translateY(-50%)"
        >
          <MdDarkMode size={11} color="white" />
        </Box>
      )}
      {colorMode === "light" && (
        <Box
          pointerEvents="none"
          position="absolute"
          top="1/2"
          right={2}
          transform="translateY(-50%)"
        >
          <CiLight size={11} color="black" />
        </Box>
      )}
    </Box>
  );
}
